<template>
  <div class="text-left w-100" id="studySurvey-page">
    <div class="mt-4 mb-0 mb-md-6 w-100">
      <div class="d-flex align-center w-100">
        <h1
          class="my-2 text-h6 font-weight-black"
          :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 2rem !important;' : ''"
        >
          Voir les problématiques que vous avez relevé
        </h1>
      </div>
    </div>

    <!-- Liste des problématiques -->
    <div class="mt-4">
      <ConcernsPagination />
    </div>
  </div>
</template>

<script>
import ConcernsPagination from "./ConcernsPagination"

export default {
  name: "ConcernsPage",
  components: { ConcernsPagination },
}
</script>
